import PropTypes from 'prop-types';
import React from 'react';
import RegisterLoginButtons from 'modules/Common/components/RegisterLoginButtons';
import MyStableIcon from 'modules/Common/components/svg/MyStableIcon';
import NotificationsIcon from 'modules/Common/components/svg/NotificationsIcon';
import VideoIcon from 'modules/Common/components/svg/VideoIcon';
import StarIcon from 'modules/Common/components/svg/StarIcon';


export default function EnhancedLoginPrompt({size = "standard", showLoginBenefits = true}) {
  require("./EnhancedLoginPrompt.scss");

  const logos = [
    [
      "sportinglife",
      "itv7-solid",
      "skybet"
    ],
    [
      "super6-solid",
      "fantasyfootball-solid",
      "fantasysixaside-solid"
    ]
  ];

  const img = logo => <img key={logo} className={`icon ${logo}`} src={`/img/login-prompt-logos/${logo}.png`}/>

  return <div className={`enhanced-login-prompt-${size}`}>
    <div className="enhanced-login-prompt-accounts">
      <div className="enhanced-login-prompt-accounts-text">You can log into Sporting Life with any of the following accounts:</div>
      <div className="enhanced-login-prompt-accounts-icons">
        {logos.map((row, i) => <span key={i} className="enhanced-login-prompt-accounts-row">{row.map(img)}</span>)}
      </div>
    </div>
    {showLoginBenefits &&
    <div className="enhanced-login-prompt-benefits">
      <div>
        Don't have any of these accounts? Register to enjoy the benefits of logging in:
      </div>

      <div className="enhanced-login-prompt-benefit-list">
        <span className="enhanced-login-prompt-benefit"><MyStableIcon title="My Stable"/> My Stable</span>{" "}
        <span className="enhanced-login-prompt-benefit"><NotificationsIcon/> Live notifications</span>{" "}
        <span className="enhanced-login-prompt-benefit"><VideoIcon/> Video form</span>{" "}
        <span className="enhanced-login-prompt-benefit"><StarIcon title="Offers"/> Exclusive offers & content</span>
      </div>
    </div>
    }
    <RegisterLoginButtons/>
  </div>;
}

EnhancedLoginPrompt.propTypes = {
  size: PropTypes.string
};

export const EnhancedLoginPromptHeading = "Log in for access to this exclusive content.";




// WEBPACK FOOTER //
// ./modules/Common/components/EnhancedLoginPrompt.js